import type { TickSystem } from '@app-games/core';
import type { GameState } from '../state.js';
import type { GameAction } from '../actions.js';

export const comboSystem: TickSystem<GameState, GameAction> = {
  name: 'combo',
  update: (state, dt, _dispatch) => {
    if (!state.isRunning) return state;
    if (state.combo.count === 0) return state;

    const newTimer = state.combo.timer - dt;
    if (newTimer <= 0) {
      return {
        ...state,
        combo: { ...state.combo, count: 0, timer: 0 },
      };
    }

    if (Math.abs(newTimer - state.combo.timer) < 0.001) return state;
    return {
      ...state,
      combo: { ...state.combo, timer: newTimer },
    };
  },
};
